import { Apis } from "../../../lib/Apis";

const unwrapResponseBody = (body) => {
  if (body == null) return null;
  if (body?.success === false) {
    throw new Error(body?.message || "Request failed.");
  }
  if (
    body &&
    typeof body === "object" &&
    "data" in body &&
    ("success" in body || "statusCode" in body)
  ) {
    return body.data;
  }
  return body;
};

const unwrapList = (body) => {
  const payload = unwrapResponseBody(body) ?? body ?? {};
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload)) return payload;
  return [];
};

export const popularInteriorDesign = () => {
  const addPopularInteriorDesign = async (data) => {
    try {
      const response = await Apis.addPopularInteriorDesign(data);
      return unwrapResponseBody(response?.data) ?? response?.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const getAllInteriorDesigns = async (setInteriorDesignData) => {
    try {
      const response = await Apis.getAllInteriorDesigns();
      const items = unwrapList(response?.data);
      setInteriorDesignData(items);
      return { data: items, ...(unwrapResponseBody(response?.data) || {}) };
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const getAllInteriorDesignNamesForPopularDesign = async (
    setInteriorDesignNames,
  ) => {
    try {
      const response = await Apis.getAllInteriorDesignNamesForPopularDesign();
      const items = unwrapList(response?.data);
      setInteriorDesignNames(items);
      return { data: items };
    } catch (error) {
      console.error(
        "Error fetching interior design names for popular design:",
        error,
      );
      throw error;
    }
  };

  return {
    addPopularInteriorDesign,
    getAllInteriorDesigns,
    getAllInteriorDesignNamesForPopularDesign,
  };
};
